import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { IBingo75GameRepresentation, Bingo75GameController } from '@/components/game/implementations/uk/bingo-75/_domain/controller/game-controller';
import { IGameStateChangedArgs, IGameRepresentationChangedArgs, GameState } from '@/components/game/_domain/models';

@Component({
  name: 'CurrentPatternComponent',
})

export default class CurrentPatternComponent extends TombolaBaseComponent {
  @Prop() public gameController: Bingo75GameController;
  public coloured: number[] = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
  public patternName: string = '';
  private gameState: GameState;

  protected mounted() {
    Vue.nextTick(() => {
      this.gameController
          .onGameStateChanged(this.handleGameStateChanged)
          .onGameRepresentationChanged(this.handleGameRepresentationChanged);
    });
    this.parsePatternString(this.gameController.patterns.currentPattern);
  }

  private parsePatternString(pattern: string) {
    const parsedColours = new Array();
    pattern.split('').forEach((element) => {
      parsedColours.push(Number(element));
    });
    this.coloured = parsedColours;
  }

  private updatePatternsDisplay() {
    this.parsePatternString(this.gameController.patterns.currentPattern);
    this.patternName = this.gameController.patterns.currentPatternName;
  }

  private handleGameStateChanged(eventArgs: IGameStateChangedArgs) {
    this.gameState = eventArgs.currentGameState;
    this.updatePatternsDisplay();
  }

  private handleGameRepresentationChanged(eventArgs: IGameRepresentationChangedArgs) {
    const bingo75EventArgs = eventArgs.currentGameRepresentation as IBingo75GameRepresentation;
    this.updatePatternsDisplay();
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/bingo-75/_components/pattern/current-pattern/current-pattern.component.ts